import React from 'react';
import { getTenant, formatCurrencyAmount } from '../../../theme/tokens';
import { useTranslation } from 'react-i18next';
import { ChevronRightIcon, CheckCircleIcon, ClockIcon, AlertCircleIcon, MoreHorizontalIcon } from 'lucide-react';
import { BulkPaymentBatch } from '../pages/BulkPayments';
interface BulkPaymentListSimplifiedProps {
  onViewDetail: (batchId: string) => void;
}
export function BulkPaymentListSimplified({
  onViewDetail
}: BulkPaymentListSimplifiedProps) {
  const {
    t
  } = useTranslation('payments');
  const recentBatches: BulkPaymentBatch[] = [{
    id: '1',
    name: 'December Invoices',
    createdAt: '2023-12-15T09:30:00',
    totalAmount: 12450.75,
    currency: getTenant().currency.code,
    totalItems: 45,
    completedItems: 38,
    status: 'completed',
    collectionRate: 84.4
  }, {
    id: '4',
    name: 'Membership Renewals',
    createdAt: '2023-12-18T16:20:00',
    totalAmount: 3600.0,
    currency: getTenant().currency.code,
    totalItems: 12,
    completedItems: 5,
    status: 'processing',
    collectionRate: 41.7
  }, {
    id: '5',
    name: 'Workshop Registrations',
    createdAt: '2023-12-10T08:30:00',
    totalAmount: 2250.0,
    currency: getTenant().currency.code,
    totalItems: 15,
    completedItems: 15,
    status: 'completed',
    collectionRate: 100.0
  }];
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric'
    });
  };
  const formatAmount = (amount: number) => {
    return formatCurrencyAmount(amount, {
      fractionDigits: 2
    });
  };
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'completed':
        return <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-green-50 text-green-700" data-id="element-6852">
            {t('components.getStatusBadge.completed')}
          </span>;
      case 'processing':
        return <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-blue-50 text-blue-700" data-id="element-6853">
            {t('components.getStatusBadge.processing')}
          </span>;
      case 'failed':
        return <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-red-50 text-red-700" data-id="element-6854">
            {t('components.getStatusBadge.failed')}
          </span>;
      default:
        return <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-gray-50 text-gray-700" data-id="element-6855">
            {status}
          </span>;
    }
  };
  return <div className="divide-y divide-gray-100" data-id="element-6856">
      {recentBatches.map(batch => <div key={batch.id} className="flex items-center py-4 cursor-pointer hover:bg-gray-50/50 transition-colors -mx-6 px-6" onClick={() => onViewDetail(batch.id)} data-id="element-6857">
          <div className="flex-1 min-w-0" data-id="element-6858">
            <p className="text-sm font-medium text-gray-900 truncate" data-id="element-6859">
              {batch.name}
            </p>
            <p className="text-xs text-gray-500 mt-0.5" data-id="element-6860">
              {batch.totalItems}{' '}
              {t('components.BulkPaymentListSimplified.payment_links')}
            </p>
          </div>
          <div className="w-36 text-right" data-id="element-6861">
            <p className="text-sm font-medium text-gray-900" data-id="element-6862">
              {formatAmount(batch.totalAmount)}
            </p>
          </div>
          <div className="w-28 flex justify-center" data-id="element-6863">
            {getStatusBadge(batch.status)}
          </div>
          <div className="w-32 text-right" data-id="element-6864">
            <p className="text-sm text-gray-500" data-id="element-6865">
              {formatDate(batch.createdAt)}
            </p>
          </div>
          <div className="w-10 flex justify-end" data-id="element-6866">
            <button aria-label="View details" className="p-1 text-gray-400 hover:text-gray-600 rounded-md hover:bg-gray-100 transition-colors" onClick={e => {
          e.stopPropagation();
          onViewDetail(batch.id);
        }} data-id="element-6867">
              <MoreHorizontalIcon size={16} aria-hidden="true" data-id="element-6868" />
            </button>
          </div>
        </div>)}
    </div>;
}